import { render, staticRenderFns } from "./testconnect.vue?vue&type=template&id=d0fcdfd6&scoped=true&"
import script from "./testconnect.vue?vue&type=script&lang=js&"
export * from "./testconnect.vue?vue&type=script&lang=js&"
import style0 from "./testconnect.vue?vue&type=style&index=0&id=d0fcdfd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fcdfd6",
  null
  
)

export default component.exports